module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__hotel--here-201943ac812fe0fc6b0a4db9d1e66b37.svg";